import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useFela } from 'react-fela';
import { formatHhMmSsShort } from '../../utils';
import { Row, Text } from '../../common';
import AdLink from './AdLink';
import ControlContainer from './ControlContainer';
import SkipNextIcon from './SkipNextIcon';
import { usePlayer } from '../../../PlayerContext';
import { largeScreen, smallScreen } from '../../../../common/mixins';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

const rules = ({ theme, isMobile }) => ({
  position: 'absolute',
  bottom: '8rem',
  left: theme.margin.xxlarge,
  right: theme.margin.xxlarge,
  padding: `0 ${theme.margin.small}`,
  extend: [
    {
      condition: isMobile,
      style: {
        position: 'fixed', // fix ios address bar and android menu bar at bottom covering player controls
      },
    },
    largeScreen({
      left: theme.margin.large,
      right: theme.margin.large,
    }),
    smallScreen({
      padding: 0,
      left: theme.margin.medium,
      right: theme.margin.medium,
    }),
  ],
});

function AdControl() {
  const player = usePlayer();
  const { css } = useFela({
    isMobile: [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os),
  });

  const {
    adSkipCountdown,
    adHasLink,
  } = useSelector(({ playback }) => ({
    adSkipCountdown: playback.adSkipCountdown,
    adHasLink: playback.adHasLink,
  }), shallowEqual);

  const skip = () => {
    player.skip();
  };

  const openAdWebsite = () => {
    player.openAdWebsite();
  };

  return (
    <div className={css(rules)}>
      <Row alignCenter justifyContent={adHasLink ? 'space-between' : 'end'}>
        {adHasLink && (
          <AdLink onClick={openAdWebsite} />
        )}
        {adSkipCountdown >= 0 && (
          <ControlContainer onClick={skip} disabled={adSkipCountdown > 0}>
            {adSkipCountdown > 0 ? (
              <Text id="skipAdInTime" values={{ time: formatHhMmSsShort(adSkipCountdown) }} bold />
            ) : (
              <>
                <Text id="skipAd" bold />
                <SkipNextIcon width={19} height={19} />
              </>
            )}
          </ControlContainer>
        )}
      </Row>
    </div>
  );
}

export default React.memo(AdControl);
